import { render, staticRenderFns } from "./LineItemsManager.vue?vue&type=template&id=22e7fe90"
import script from "./LineItemsManager.vue?vue&type=script&lang=js"
export * from "./LineItemsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports